export function createBookingCopy(
  booking,
  { uuid, counterBooking, date, time, isReturn = false },
) {
  const copy = {
    ...booking,
    uuid,
    counterBooking,
    date,
    time,
  };

  delete copy.subRoutesList;

  if (isReturn) {
    copy.origin = booking.destination;
    copy.destination = booking.origin;
  }

  return copy;
}
